export enum PayRateFieldNames {
    payRate = 'payRate',
    overtimeFactor = 'payOvertimeFactor',
    callBackFactor = 'payCallBackFactor',
    doubleTimeFactor = 'payDoubletimeFactor',
    holidayFactor = 'payHolidayFactor',
    onCallRate = 'payOnCallRate',
    charge = 'payCharge',
    amountPerMile = 'payAmountPerMile',
    guaranteedHours = 'payGuaranteedHours',
    preceptor = 'payPreceptor',
    additionalPremiumPay = 'additionalPremiumPay',
  }